// Couleur visuelle d'une ceinture (pastille). Choisit la couleur la plus avancée d'un nom composé.
export function beltHex(belt) {
  const b = (belt || "").toLowerCase();
  const order = [
    ["noir", "#111827"], ["brun", "#78350f"], ["mauve", "#a855f7"], ["bleu", "#3b82f6"],
    ["vert", "#22c55e"], ["orange", "#fb923c"], ["rouge", "#ef4444"], ["jaune", "#facc15"], ["blanc", "#f4f4f5"],
  ];
  for (const [k, hex] of order) { if (b.includes(k)) return hex; }
  return "#71717a";
}

// Texte lisible sur la couleur de ceinture (fond clair → texte sombre).
export function beltTextColor(belt) {
  const b = (belt || "").toLowerCase();
  return /jaune|blanc|orange|vert/.test(b) ? "#0a0a0a" : "#ffffff";
}
